export default "__VITE_ASSET__DW9CWqxv__"